<script setup lang="ts">
import { resolveAdminCompanyByExactGuid } from '@swipe4work/api-orval'
import { useToast } from '@/shared/composables/UseToast'

/*
 * Metabase dashboards only know the Exact Online account guid, so their click-through links point here.
 * This page resolves the guid to our own company id and forwards to that company's detail page.
 */
definePage({
  path: '/forward/exact-company/:exactGuid',
  name: 'forward.exact-company',
  meta: {
    title: 'Doorverwijzen naar bedrijf',
    hideBreadcrumb: true,
    permission: {
      resource: 'Company',
      level: 'Read',
    },
  },
})

const route = useRoute()
const router = useRouter()
const toast = useToast()

const exactGuid = (route.params as { exactGuid?: string }).exactGuid ?? ''

async function forwardToCompany() {
  try {
    const { companyId, matchCount } = await resolveAdminCompanyByExactGuid(exactGuid)

    if (!companyId) {
      toast.error('Bedrijf niet gevonden', 'Er is geen bedrijf gekoppeld aan dit Exact Online-account.')
      await router.replace({ name: 'companies.overview' })

      return
    }

    if (matchCount > 1) {
      toast.warn(
        'Meerdere bedrijven gekoppeld',
        `Dit Exact Online-account is aan ${matchCount} bedrijven gekoppeld. Het hoofdbedrijf is geopend.`,
      )
    }

    await router.replace({
      name: 'companies.[id]',
      params: { id: String(companyId) }, 
    })
  } catch {
    toast.error('Doorverwijzen mislukt', 'Het bedrijf bij dit Exact Online-account kon niet worden opgehaald.')
    await router.replace({ name: 'companies.overview' })
  }
}

onMounted(forwardToCompany)
</script>

<template>
  <div class="flex flex-col items-center justify-center gap-3 py-20 text-surface-600">
    <ProgressSpinner style="width: 3rem; height: 3rem" />
    <p class="m-0">
      Bedrijf wordt opgezocht…
    </p>
  </div>
</template>
